import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _JSON$stringify from 'babel-runtime/core-js/json/stringify';
import _extends from 'babel-runtime/helpers/extends';

import { fmtSize, qcAssetLoadAsync, getUUID } from '@ps/utils/game.js';
import { readFile, saveFile } from '@ps/api/editor/file';
import ResourceLabelBar from './ResourceLabelBar.vue';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import { GamePage } from '@ps/utils/config';
export default {
  components: {
    ResourceLabelBar: ResourceLabelBar
  },
  name: 'FileItem',
  props: {
    fileList: {
      type: Array,
      require: true
    },
    curDir: {
      type: String,
      require: true
    },
    projectKey: {
      type: String,
      require: true
    },
    isRadio: {
      type: Boolean,
      require: false
    }
  },
  data: function data() {
    return {
      dialogTableVisible: false,
      currentContent: '',
      currentTitle: '',
      currentImg: '',
      isImg: false,
      radioVal: ''
    };
  },

  filters: {
    getSize: function getSize(value) {
      return fmtSize(value);
    }
  },
  computed: _extends({}, mapState({
    gameOb: function gameOb(state) {
      return state.workspace.game.game;
    },
    qc: function qc(state) {
      return state.workspace.game.data;
    }
  }), mapGetters({
    gamePlay: 'workspace/game/gamePlay'
  })),
  methods: _extends({}, mapMutations({
    updateCurPage: 'workspace/game/updateCurPage',
    updateEditingPrefabPath: 'workspace/game/prefab/updateEditingPrefabPath'
  }), mapActions({
    initHistory: 'workspace/game/history/initHistory'
  }), {
    // 清除选中框，被父组件调用
    clearSelection: function clearSelection() {
      this.$refs.multipleTable.clearSelection();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      var arr = [];
      val.forEach(function (item) {
        arr.push(item.name);
      });
      this.$emit('getCurrSection', arr);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      if (this.isRadio && val) {
        this.radioVal = val.name;
        this.$emit('getCurrSection', [val.name]);
      }
    },


    // 点击文件
    handleRowClick: function handleRowClick(rows) {
      var _this = this;

      // 点击直接下载的文件格式
      var downLoadExt = ['.ts', '.mp3'];
      // 判断是否是直接下载的文件格式
      if (downLoadExt.indexOf(rows.ext) !== -1) {
        this.$emit('isLoading', true);
        readFile({
          responseType: 'blob',
          pid: this.projectKey,
          path: rows.name
        }).then(function (res) {
          // 通过二进制文件创建url
          var url = window.URL.createObjectURL(res);

          var a = document.createElement('a');
          a.href = url;
          a.download = rows.name.split('/').pop();
          a.click();
          // 销毁创建的url
          window.URL.revokeObjectURL(url);
        }).catch(function (err) {
          console.log('error', err);
        }).finally(function () {
          _this.$emit('isLoading', false);
        });
      } else {
        if (!rows.is_dir) {
          var idx = rows.name.lastIndexOf('/');
          this.currentTitle = rows.name.slice(idx + 1);
          if (rows.ext === '.png' || rows.ext === '.jpg') {
            this.currentImg = '/project/preview/' + this.projectKey + rows.name;
            this.isImg = true;
            this.dialogTableVisible = true;
          } else {
            this.isImg = false;
            readFile({
              pid: this.projectKey,
              path: rows.name
            }).then(function (res) {
              if (res instanceof Object) {
                _this.currentContent = _JSON$stringify(res, null, 4);
              } else {
                _this.currentContent = res;
              }
              _this.dialogTableVisible = true;
            }).catch(function (err) {
              console.log('error', err);
            });
          }
        } else {
          // 当前是点击的是目录
          this.$emit('changeDir', rows);
        }
      }
    },
    changeFileContent: function changeFileContent() {
      var _this2 = this;

      this.dialogTableVisible = false;
      var temp = new Blob([this.currentContent]);
      var fileObj = new File([temp], this.currentTitle);
      saveFile({
        pid: this.projectKey,
        path: this.curDir + this.currentTitle
      }, fileObj).then(function (res) {
        if (res.code !== 0) {
          _this2.$message({
            type: 'error',
            message: res.msg
          });
        } else {
          _this2.$message({
            type: 'success',
            message: '保存成功'
          });
        }
      }).catch(function (err) {
        console.log('err', err);
      });
    },
    renameHandler: function renameHandler(srcPath, dstPath) {
      this.$emit('rename', srcPath, dstPath);
    },
    editHandler: function editHandler(info) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var path, res, node;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                path = info.name;

                if (info.name.indexOf('/') === 0) {
                  path = info.name.slice(1);
                }
                _context.next = 4;
                return qcAssetLoadAsync(getUUID(path), path);

              case 4:
                res = _context.sent;

                if (res instanceof _this3.qc.Prefab) {
                  _this3.updateEditingPrefabPath(path);
                  node = _this3.gameOb.add.clone(res, _this3.gameOb.world);

                  _this3.initHistory({ node: node });
                  _this3.updateCurPage(GamePage.PREFAB);
                } else {
                  _this3.$message.info('非预资源不能编辑');
                }

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    tableRowClassName: function tableRowClassName(_ref) {
      var row = _ref.row,
          rowIndex = _ref.rowIndex;

      if (row.selected) {
        return 'selected-row';
      }
      return '';
    }
  })
};